import {
  AdminSchedule,
  Frequency
} from '@dadohr/shared/domainTypes/adminSchedules';
import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { FS } from '@dadohr/shared/versions';
import moment from 'moment-timezone';
import { getCurrentUser } from '../currentUser';
import { store } from '../firebase';
import { fromMoment, now } from '../time';

export const toAdminScheduleDoc = generateToDocFn<AdminSchedule>();

export const getNextRunDate = (now: moment.Moment, frequency: Frequency) => {
  if (frequency.type === 'NONE') {
    return null;
  }
  const nowInTz = now.clone().tz(frequency.tz);
  const currentHour = nowInTz.hour();
  const { hour } = frequency;
  if (frequency.type === 'X_HOURLY') {
    const nextRun = moment.tz(frequency.tz).startOf('d').hour(hour);
    if (hour <= nowInTz.hour() && nextRun.day() === nowInTz.day()) {
      nextRun.add(frequency.interval, 'h');
    }
    return fromMoment(nextRun);
  }
  if (frequency.type === 'DAILY') {
    const nextRun = moment.tz(frequency.tz).startOf('d').hour(hour);
    if (hour <= currentHour) {
      nextRun.add(1, 'd');
    }
    return fromMoment(nextRun);
  }

  const currentWeekday = nowInTz.day();
  if (frequency.type === 'WEEKLY') {
    const weekday = frequency.weekDay;
    const nextRun = moment
      .tz(frequency.tz)
      .startOf('d')
      .hour(hour)
      .day(weekday);
    if (weekday < currentWeekday) {
      nextRun.add(1, 'w');
    }
    if (weekday === currentWeekday) {
      if (hour <= currentHour) {
        nextRun.add(1, 'w');
      }
    }
    return fromMoment(nextRun);
  }

  return null;
};

export const updateOrCreateSchedule = (
  docId: string,
  data: Partial<AdminSchedule> & { frequency: Frequency; active: boolean },
  changeReason?: string
) => {
  // Audit attachment so the new-main admin-schedules onUpdate trigger can
  // attribute toggle changes (active / options.autoApply) to a specific
  // admin user when alerting Slack. Mirrors apps/src/services/user/import.ts
  // lastStatusChange pattern. See new-main-793.
  const lastChange = {
    changedAt: now(),
    changedBy: getCurrentUser().id,
    reason: changeReason ?? ''
  };
  return store()
    .collection(FS.adminSchedules)
    .doc(docId)
    .set(
      {
        ...data,
        nextRun: getNextRunDate(moment.utc(), data.frequency),
        lastChange
      },
      { merge: true }
    );
};
